<div class="p-4" *ngIf="isEsdpGroupNotEmpty()">
  <div class="mb-3">
    <p *ngIf="isEsdpGroupNotEmpty()" class="groups-title">
      Группы которые подходят к ESDP:
    </p>
    <div *ngIf="groupsList$" class="groups-links">
      <div *ngFor="let group of groupsList$" class="mr-3 position-relative">
        <a
          [routerLink]="getRouteByStatusGroup(group?.course)"
          class="groups-link">
          {{ group.full_name }} /
          <span
            >Дата старта ESDP :
            <span class="text-danger"
              >{{ group['esdp_start_date'] | date }}
            </span></span
          >
        </a>
      </div>
    </div>
  </div>
</div>

<div class="p-5 text-center" *ngIf="!isEsdpGroupNotEmpty()">
  <span>Все группы запущены на ESDP</span>
</div>
